export enum PostStatus {
  Publish = 'publish',
  Archival = 'archival',
  AwaitingForApproval = 'awaitingForApproval',
}
